import mime from 'mime-types';

export const getFullDataURI = ({body, file_extension}) => {
  const mimeType = mime.lookup(file_extension);
  return `data:${mimeType};base64,${body}`;
};